import React from 'react';
import Svg from '../Svg';

import { IconProps } from '../icon';

export const Products20 = ({
  accessibilityLabel,
  contrast,
  className,
}: IconProps) => (
  <Svg
    accessibilityLabel={accessibilityLabel}
    size={20}
    contrast={contrast}
    className={className}
  >
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M4.75 2.5C4.75 1.80964 5.30964 1.25 6 1.25H17.5C18.1904 1.25 18.75 1.80964 18.75 2.5V14C18.75 14.6904 18.1904 15.25 17.5 15.25H6C5.30964 15.25 4.75 14.6904 4.75 14V2.5ZM6.25 2.75V4.25H7.75V2.75H6.25ZM6.25 13.75V5.75H17.25V13.75H6.25ZM17.25 2.75V4.25H9.25V2.75H17.25Z'
      fill='currentColor'
    />
    <path
      d='M2.75 5.5V17.25H14.5V18.75H2.5C1.80964 18.75 1.25 18.1904 1.25 17.5V5.5H2.75Z'
      fill='currentColor'
    />
  </Svg>
);

Products20.displayName = 'Products20';
export default Products20;
